export * from './text-input-highlight.module';
export * from './highlight-tag.interface';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.ts